import { updateChatbotState } from "./Utils";
import {API_BASE} from "../../../services/apirest";

export const manejarValidacionCobertura = async (
    newMessage,
    metodo,
    setState,
    createChatBotMessage
) => {
    let url = `${API_BASE}/cobertura.php?`;

    if (metodo === "direccion") {
        // Extraer datos en formato esperado: "calle, número, colonia"
        const partes = newMessage.split(",");
        if (partes.length < 3 ) {
            updateChatbotState(
                setState,
                createChatBotMessage(
                    "Formato incorrecto. Ingresa los datos en el siguiente formato: calle, número, colonia."
                )
            );
            return;
        }
        // Sanitizar datos
        const calle = encodeURIComponent(partes[0].trim());
        const numero = encodeURIComponent(partes[1].trim());
        const colonia = encodeURIComponent(partes[2].trim());

        // Construcción de la URL con parámetros
        const API_BASE = url + `calle=${calle}&numero=${numero}&colonia=${colonia}`;

        try {
            const response = await fetch(API_BASE);
            if (!response.ok) throw new Error("Error al obtener datos de la API");

            const data = await response.json();

            console.log(data)

            // Evaluar la respuesta de la API
            if (data.status === "success") {
                updateChatbotState(
                    setState,
                    createChatBotMessage(
                        `✅ Cobertura disponible en:\n📍 ${data.result.datos.CALLE} #${data.result.datos.NO_EXTERIOR}, ${data.result.datos.COLONIA}`,
                        { widget: "coberturaMessage", payload: { cobertura: data.result.datos } }
                    )
                );
            } else {
                updateChatbotState(
                    setState,
                    createChatBotMessage("❌ No hay cobertura en la dirección proporcionada.")
                );
            }
        } catch (error) {
            updateChatbotState(
                setState,
                createChatBotMessage(`Hubo un error procesando tu solicitud: ${error.message}`)
            );
        }

    } else if (metodo === "codigoPostal") {
        // Extraer datos en formato esperado: "código postal"
        const partes = newMessage.split(",");
        if (partes.length < 1) {
            updateChatbotState(
                setState,
                createChatBotMessage(
                    "Formato incorrecto. Ingresa los datos en el siguiente formato: código postal."
                )
            );
            return;
        }

        // Sanitizar datos
        const cp = encodeURIComponent(partes[0].trim());

        // Construcción de la URL con parámetros
        const API_BASE = url + `cp=${cp}`;
        try {
            const response = await fetch(API_BASE);
            if (!response.ok) throw new Error("Error al obtener datos de la API");

            const data = await response.json();

            console.log("Resultado de data", data);

            // Validar que la respuesta tiene datos
            if (
                !data ||
                data.status !== "success" || // Validar el status del nivel superior
                !data.result ||
                data.result.status !== "OK" || // Validar el status dentro de result
                !Array.isArray(data.result.datos) ||
                data.result.datos.length === 0
            ) {
                throw new Error("No hay cobertura en el código postal proporcionado.");
            }

            // Evaluar la respuesta de la API
            if (data.status === "success" && data.result.status === "OK") {
                const colonias = data.result.datos.map(item => `📍 ${item.COLONIA}`).join("\n");

                updateChatbotState(
                    setState,
                    createChatBotMessage(
                        `✅ Cobertura disponible en el código postal: ${data.result.datos[0].CP}\n${colonias}`,
                        { widget: "coberturaMessage", payload: { cobertura: data.result.datos } }
                    )
                );
            } else {
                updateChatbotState(
                    setState,
                    createChatBotMessage("❌ No hay cobertura en el código postal proporcionado.")
                );
            }
        } catch (error) {
            updateChatbotState(
                setState,
                createChatBotMessage(`Hubo un error procesando tu solicitud: ${error.message}`)
            );
        }
    }

};